    web = window.web = window.web || {};

    var $ = require('jquery');

    web.Director = module.exports = function(options) {
        var t = this;
        t.instanceState = 'constructed';

        t.defaults = {};

        t.instances = {};

        t.iscrollInstances = {};

        t.options = $.extend({}, t.defaults, options);

        t.baseUrl = null;
    };

    web.Director.prototype = {
        init:  function(){
            var t = this;
            t.instanceState = 'inicialized';

            //Vytvoření instancí
            t._constructInstances();

            //Bind událostí instacní
            t._bindEvents();

            //Vlastní procesy instancí
            t._initInstances();


            $(t).trigger({
                type: "inicialized"
            });
        },

        _constructInstances: function(){
            var t = this;
            t.instances = {
                paramResolver: new web.ParamResolver(),
                slideLinks: new web.SlideLinks(),
                anchorSlider: new web.AnchorSlider(),
                urlStateCommiter: new web.UrlStateCommiter(),
                //device: new web.Device(),
                preloader: new web.Preloader(),
                socialShare: new web.SocialShare(),
                contentLoader: new web.ContentLoader()
            }
        },

        _prepareIScrollNavbarWidth: function($menuWrapper){

            var t = this;
            var $navbar =  $menuWrapper.find(".navbar.navbar-main");
            var $conteiner = $menuWrapper.find(".navbar.navbar-main > .container");
            $navbar.css({
                width: 100000
            });

            var width = 870;

            $conteiner.css({float: 'left'});
            width = $conteiner.outerWidth()+10;
            $conteiner.css({float: 'inherit'});

            $navbar.css({
                width: width
            });
        },

        _prepareIScrollTabWidth: function($menuWrapper){

            var t = this;
            var $navbar =  $menuWrapper.find(".tab-wrapper-overflower");
            var $conteiner = $menuWrapper.find(".nav-tabs");
            $navbar.css({
                width: 100000
            });

            var width = 870;

            $conteiner.css({float: 'left'});
            width = $conteiner.outerWidth()+1;
            $conteiner.css({float: 'inherit'});

            $navbar.css({
                width: width
            });
        },

        _initMainMenuIScroll: function(){
            var t = this;
            t._destroyMainMenuIScroll();


            t._prepareIScrollNavbarWidth($(".js_iscroll-menu-wrapper"));


            t.iscrollInstances.menu = new web.IScroll(".js_iscroll-menu-wrapper", {
                scrollX: true,
                scrollY: false,
                mouseWheel: true,
                click: true,
                tap: true
            });

            window.setTimeout(function(){
                t.iscrollInstances.menu.scrollTo(0,0,1000)
            },600);

            window.setTimeout(function(){
                t.iscrollInstances.menu.refresh();
            },150);
            window.setTimeout(function(){
                t.iscrollInstances.menu.refresh();
            },300);
            window.setTimeout(function(){
                t.iscrollInstances.menu.refresh();
            },500);
            window.setTimeout(function(){
                t.iscrollInstances.menu.refresh();
            },750);
            window.setTimeout(function(){
                t.iscrollInstances.menu.refresh();
            },1000);



        },

        _destroyMainMenuIScroll: function(){
            var t = this;

            try {
                t.iscrollInstances.menu.destroy();
                t.iscrollInstances.menu = null;

                var $main =  $(".js_iscroll-menu-wrapper").find(".navbar.navbar-main");

                $main.css({
                    width: 'auto'
                })

                $main.css({
                    "transition": "all .35s linear;",
                    "-webkit-transition": "all .35s linear;",
                    "transform": "translate(0px, 0px) translateZ(0px)"
                })

            } catch (e){

            }


        },

        _initTabIScroll: function(){
            var t = this;

            var $elm =  $(".js_iscroll-tab-wrapper");

            const urlHash = window.location.hash;
            // var topOffset = document.querySelector('.header-fixed').offsetHeight;

            var headerFixed = document.querySelector('.header-fixed');
            var topOffset = headerFixed ? headerFixed.offsetHeight : 0;

            if ($elm.length > 0) {
            t._prepareIScrollTabWidth($elm);

                t.iscrollInstances.tab = new web.IScroll(".js_iscroll-tab-wrapper", {
                    scrollX: true,
                    scrollY: false,
                    mouseWheel: true,
                    click: true,
                    tap: true
                });

                // SHAKE
                t.iscrollInstances.tab.scrollTo(-20, 0, 300)

                if (urlHash === "#downloadsTabs") {
                    $('html, body').animate({
                        scrollTop: $('#downloadsTabs').offset().top - topOffset
                    }, 'slow');
                    $('.nav-tabs a[href="#tab-7"]').tab('show');
                    $('.tab-wrapper-overflower').css("transform", "translateX(-436px)");
                } else if( urlHash === "#downloadsTabs-0") {
                    $('html, body').animate({
                        scrollTop: $('#downloadsTabs').offset().top - topOffset
                    }, 'slow');
                    $('.nav-tabs a[href="#tab-0"]').tab('show');
                    $('.tab-wrapper-overflower').css("transform", "translateX(0px)");
                } else if( urlHash === "#downloadsTabs-5") {
                    $('html, body').animate({
                        scrollTop: $('#downloadsTabs').offset().top - topOffset
                    }, 'slow');
                    $('.nav-tabs a[href="#tab-5"]').tab('show');

                    $('.tab-wrapper-overflower').css("transform", "translateX(-160px)");
                } else if( urlHash === "#downloadsTabs-6") {
                    $('html, body').animate({
                        scrollTop: $('#downloadsTabs').offset().top - topOffset
                    }, 'slow');
                    $('.nav-tabs a[href="#tab-6"]').tab('show');

                    $('.tab-wrapper-overflower').css("transform", "translateX(-300px)");
                } else {
                    window.setTimeout(function () {
                        t.iscrollInstances.tab.scrollTo(0, 0, 1000)
                    }, 600);
                }
            }


        },

        _bindEvents: function(){
            var t = this;
            t.instanceState = 'binded';

            //Vsechno je ready
            $(t).on("inicialized", function(){
                t._processCommonOnContext();
                t._setParamResolver();

                t._initTabIScroll();

                t.baseUrl = location.href;
            });



            //Iscroll init
            $('.js_iscroll-menu-wrapper').on('shown.bs.collapse', function () {
                t._initMainMenuIScroll();
            });

            $('.js_iscroll-menu-wrapper').on('hidden.bs.collapse', function () {
                t._destroyMainMenuIScroll();
            });

            $('.js_iscroll-menu-wrapper').on('show.bs.collapse', function () {
                $(".js_iscroll-menu-wrapper").find(".navbar.navbar-main").css({
                    width: '1000'
                })
            });

            //Device events
            /* $(t.instances.device).on("deviceChange", function(e){

                if (e.device.label != 'xs') {
                    t._destroyMainMenuIScroll();
                } else {
                    t._initMainMenuIScroll();
                }

            }); */



            $(t.instances.slideLinks).on("afterSlideDown", function(e){
                var $btn = $(e.btnElement);
                //t.instances.urlStateCommiter.commit('slideOpen', $btn.data("slideLinksTarget") || null, $btn.data("slideLinksBaseUrl") || null);
                //t.instances.urlStateCommiter.commit('scrollTo', $btn.data("slideLinksTarget") || null, $btn.data("slideLinksBaseUrl") || null);
            });

            $(t.instances.slideLinks).on("beforeSlideUp", function(e){
                var $btn = $(e.btnElement);
                //t.instances.urlStateCommiter.commit('slideOpen', "");
                //t.instances.urlStateCommiter.commit('scrollTo', '');
            });

            // Pri zavirani slidu
            $(t.instances.slideLinks).on("beforeSlideUp", function(e){

                //Neko sliduje s movies detailem
                if($(e.slideElement).hasClass("movie-detail")){
                    var $btn = $(e.btnElement);
                    var $btnParent = $btn.parent();
                    var $triangel = $btnParent.find(".triangel");
                    var slideInterval = t.instances.slideLinks.getInterval();

                    $btnParent.animate({
                        'margin-bottom': 0
                    }, slideInterval);
                    $triangel.fadeOut(slideInterval/5);

                }


            });



            //Partial update listener
            $("body").on("afterContentsReplaced", function(e){
                if (typeof e.target != 'null') {
                    t._processCommonOnContext(e.target);
                }
            });



            $(t.instances.contentLoader).on("xhrBeforeSend", function(e){
                t.instances.anchorSlider.scrollTo($("body"), 0);

                t.instances.preloader.show();

            });



            $(t.instances.contentLoader).on("xhrComplete", function(e){
                t.instances.preloader.hide();

            });



        },

        _initInstances: function(){
            var t = this;
            for (var i in t.instances) {
                t.instances[i].init();
            }
        },

        /*
         Konfigurace paramResolveru
         */
        _setParamResolver: function(){
            var t = this;

            //ContentLoader
            t.instances.paramResolver.setParamEvent("getContentUrl", function(value, oterParams){

                //http://localhost:8080/en/credits?getContentUrl=/en/credits/testimonial/sadgfasd-10135&contentWrapperSelector=.js_contentLoader-contentWrapperSelector&appendSelector=.js_contentLoader-contentWrapperAppender
                var contentWrapperSelector = oterParams.contentWrapperSelector;
                var appendSelector = oterParams.appendSelector;

                t.instances.contentLoader.getContent(value, contentWrapperSelector, null, null, function($content){
                    t.instances.contentLoader.appendContent(appendSelector, $content, $("body"));
                }, null);

            });


            //SlideLinksOpen
            t.instances.paramResolver.setParamEvent("slideOpen", function(value, oterParams){
                t.instances.slideLinks.processSlideLink({
                        slideLinksTarget: value
                    },
                    $("*[data-slide-links-target='"+value+"']")
                );
            });

            if (location.pathname.indexOf('/en/credits') != -1) {

                t.instances.paramResolver.setParamEvent("enteredFulltextQuery", function(value, oterParams){

                    if (!oterParams.slideOpen) {
                        var found$elm = $('*:containsi(\''+value+'\')').last();
                        var $elmParent =  found$elm.parents(".movie-detail");
                        var parentId = $elmParent.attr("id");

                        if (found$elm.length >0 && $elmParent.length>0) {
                            t.instances.slideLinks.processSlideLink({
                                    slideLinksTarget: parentId
                                },
                                $("*[data-slide-links-target='"+parentId+"']")
                            );

                            _scrollTo(parentId);
                        }
                    }


                });
            }


            function _scrollTo(value) {
                t.instances.preloader.show();

                function _temp(){

                    //preloader
                    window.setTimeout(function(){
                        var headerHeight = 0;
                        if ($(".header-fixed").css("position") == "fixed") {
                            headerHeight = $(".header-fixed").outerHeight();
                        }
                        if (value.indexOf("slideLinksMovies")!=-1){
                            t.instances.anchorSlider.scrollTo($("#"+value), -(headerHeight+$("#"+value).parents(".movie-item").find(".movie-img").height()));
                        } else if (value.indexOf("slideLinksCommercials")!=-1) {
                            t.instances.anchorSlider.scrollTo($("#"+value), -(headerHeight+$("#"+value).parents(".movie-item").find(".movie-img").height()));
                        } else {
                            t.instances.anchorSlider.scrollTo($("#"+value), -(headerHeight));
                        }

                        t.instances.preloader.hide();
                    },200);

                }
                if (document.readyState === "complete") {
                    _temp();
                }
                $(window).load(function(){
                    _temp();
                });
            }

            t.instances.paramResolver.setParamEvent("callAction", function(value, otherParams){
                if (value == "open") value = "click";
                //console.log(value);
                $(otherParams.callActionSelector)[value]();

            });

            //ScrollTo
            t.instances.paramResolver.setParamEvent("scrollTo", function(value, oterParams){
                _scrollTo(value);
            });

            t.instances.paramResolver.executeParamsResolving();

        },

        /*
         Tato metoda nad zaslanym kontextem zpracovává všechny běžné JS
         */
        _processCommonOnContext: function(context){
            var t = this;

            if (typeof context == "undefined") var context = $("body");
            if (!(context instanceof jQuery)) var context = $(context);



        }

    }




// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/Director.js